<template>
  <div class="product--image__container" :class="{'thumbnail': thumbnail !== false}">
    <img
      v-show="hasImage && !error"
      class="product--image"
      :src="src"
      @error="onError"
    />

    <div
      v-if="!hasImage || error"
      class="product--image__placeholder d-flex justify-center align-center height-100"
    >
      <span class="text-xs-center">No Image Now</span>
    </div>

    <div v-if="loading" class="product--image__overlay d-flex justify-center align-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'product-image',

    props: {
      src: String,

      loading: Boolean,

      thumbnail: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        error: false
      }
    },

    computed: {
      hasImage () {
        return !!this.src
      }
    },

    watch: {
      src () {
        // reset whenever the src attribute change
        this.error = false
      }
    },

    methods: {
      onError () {
        this.error = true
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '~vuetify/src/styles/styles'

  .product--image
    &__container
      position: relative
      width: 100%
      height: 492px

      @media #{map-get($display-breakpoints, 'xs-only')}
        height: 276px

      > *
        width: 100%
        height: 100%
        object-fit: contain

      &.thumbnail
        height: 411px

        @media #{map-get($display-breakpoints, 'xs-only')}
          height: 199px

    &__placeholder
      border: 1px solid black

    &__overlay
      position: absolute
      width: 100%
      height: 100%
      top: 0
      left: 0
      bottom: 0
      right: 0
      background-color: rgba(grey, 0.75)
</style>



// WEBPACK FOOTER //
// src/components/Product/Image.vue